import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./index.scss";

export const DIRECTIONS = {
	UP: "up",
	DOWN: "down",
	RIGHT: "right",
	LEFT: "left",
};

export const SIZES = {
	SMALL: "small",
};

export const THEMES = {
	DARK_GRAY: "darkGray",
};

const Popover = ({
	hide,
	size,
	theme,
	alignText,
	title,
	image,
	message,
	classNames,
	arrowDirection,

	confirmText,
	onConfirm,
	confirmButtonColor,
	dismissText,
	onDismiss,
	dismissButtonColor,
}) => {
	if (hide) {
		return null;
	}

	const containerClasses = classnames({
		"reactPopover": true,
		"reactPopover--alignTextLeft": alignText && alignText === DIRECTIONS.LEFT,
		"reactPopover--alignTextRight": alignText && alignText === DIRECTIONS.RIGHT,
		"reactPopover--small": size && size === SIZES.SMALL,
		"reactPopover--darkGray": theme && theme === THEMES.DARK_GRAY,
		[classNames]: !!classNames,
	});

	const arrowClasses = classnames({
		"reactPopover-arrow": true,
		"reactPopover-arrow--up": arrowDirection === DIRECTIONS.UP,
		"reactPopover-arrow--down": arrowDirection === DIRECTIONS.DOWN,
		"reactPopover-arrow--left": arrowDirection === DIRECTIONS.LEFT,
		"reactPopover-arrow--right": arrowDirection === DIRECTIONS.RIGHT,
	});

	const confirmButtonClasses = classnames({
		"reactPopover-actions-button": true,
		"flatbutton": true,
		"red": !confirmButtonColor,
		[confirmButtonColor]: !!confirmButtonColor,
	});

	const dismissButtonClasses = classnames({
		"reactPopover-actions-button": true,
		"flatbutton": true,
		"silver": !dismissButtonColor,
		[dismissButtonColor]: !!dismissButtonColor,
	});

	return (
		<div className={containerClasses}>
			<div className="reactPopover-contents">
				{image &&
					<div className="reactPopover-image">
						<img
							alt="popover"
							className="reactPopover-image-content"
							src={image}
						/>
					</div>
				}

				<h2 className="reactPopover-title">{title}</h2>
				<p className="reactPopover-message">{message}</p>

				<div className="popover-actions">
					{confirmText && onConfirm &&
						<button onClick={onConfirm} className={confirmButtonClasses}>
							{confirmText}
						</button>
					}

					{dismissText && onDismiss &&
						<button onClick={onDismiss} className={dismissButtonClasses}>
							{dismissText}
						</button>
					}
				</div>
			</div>

			<div className={arrowClasses} />
		</div>
	);
};

Popover.propTypes = {
	arrowDirection: PropTypes.oneOf([
		DIRECTIONS.UP,
		DIRECTIONS.DOWN,
		DIRECTIONS.RIGHT,
		DIRECTIONS.LEFT,
	]).isRequired,
	title: PropTypes.string.isRequired,

	hide: PropTypes.bool,
	size: PropTypes.oneOf([
		SIZES.SMALL,
	]),
	theme: PropTypes.oneOf([
		THEMES.DARK_GRAY,
	]),
	alignText: PropTypes.oneOf([
		DIRECTIONS.RIGHT,
		DIRECTIONS.LEFT,
	]),
	image: PropTypes.string,
	message: PropTypes.string,
	classNames: PropTypes.string,
	confirmText: PropTypes.string,
	onConfirm: PropTypes.func,
	confirmButtonColor: PropTypes.string,
	dismissText: PropTypes.string,
	onDismiss: PropTypes.func,
	dismissButtonColor: PropTypes.string,
};

Popover.defaultProps = {
	hide: false,
	size: null,
	theme: null,
	alignText: null,
	image: null,
	message: null,
	classNames: null,
	confirmText: null,
	onConfirm: null,
	confirmButtonColor: null,
	dismissText: null,
	onDismiss: null,
	dismissButtonColor: null,
};

export default Popover;



// WEBPACK FOOTER //
// ./src/shared/components/Popover/index.jsx